import primaryFeatureCtaBannerStyles from './primary-feature-cta-banner';

if (document.querySelector('.primary-feature-cta-banner-component')) {
  var primaryFeatureCtaBanner = document.querySelector('.primary-feature-cta-banner-component'); var cta = document.querySelector('.primary-feature-cta-banner__form .cta'); setRadioButtonEventListeners()
}
function setActiveOption(option) {
  cta.href = option.dataset.href; cta.innerHTML = option.dataset.cta;
  if (option.id == 'commercialQuoteRadio') {
    primaryFeatureCtaBanner.classList.remove('residential-quote-active')
  } else { primaryFeatureCtaBanner.classList.add('residential-quote-active') }
}
function setRadioButtonEventListeners() {
  let radioButtons = document.querySelectorAll('.primary-feature-cta-banner__form-radios input[name="quoteType"]');
  for (var i = 0; i < radioButtons.length; i++){
    radioButtons[i].addEventListener('click', (e) => { setActiveOption(e.target) })
  }
}
